import React, { useEffect, useState } from "react";
import { currencyUSD } from "../../helpers/forms/formater";
import DataTableElement from "../../components/elements/DataTableElement";
import GenericCard from "../../components/cards/GenericCard";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../components/form/CustomSelect";
import CustomSearchInput from "../../components/form/CustomSearchInput";
import Columns from "./Columns";
import { salesResource, categoriesResource } from "../../helpers/configRoutes/backend_helper";
import ModalNewSeller from "./ModalNewSeller";
import { useDispatch } from "react-redux";
import { update_category, reset_category } from "../../store/categories/action";

const Categories = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [tableLoad, setTableLoad] = useState({ show: false, textLoad: 'Buscando ventas...' });
    const [filters, setFilters] = useState({
        vendedor: '',
        cliente: '',
        servicio: '',
        search: ''
    });
    const [items, setItems] = useState([]);
    const [modal, setModal] = useState({ show:false})

    useEffect(() => {
        const getItems = async () => {
            const response = await categoriesResource('get', {});
            setItems(response.categories);
        };
        getItems();
    }, [filters]);

    const opcionesMock = [
        { id: 1, nombre: 'Opción 1' },
        { id: 2, nombre: 'Opción 2' },
        { id: 3, nombre: 'Opción 3' },
        { id: 4, nombre: 'Opción 4' },
        { id: 5, nombre: 'Opción 5' }
    ];

    const addUpd = async(category = false) => {
        if (category.id) {
            dispatch(update_category(category))
        } else {
            dispatch(reset_category())
        }
        setModal({ ...modal, show: true })
    }

    const cols = Columns(addUpd);

    return (
        <div className="flex flex-col w-full p-4 space-y-4">
            {/* Encabezado y botones arriba a la derecha */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                    <h1 className="text-fr-dark text-2xl font-bold">Panel de areas de productos</h1>
                    <p className="text-fr-muted text-sm">Consulta y filtra ventas por diferentes criterios</p>
                </div>

                <div className="flex gap-2">
                    <button
                        onClick={() => addUpd()}
                        className="flex items-center gap-2 bg-fr-primary text-white px-4 py-2 rounded-lg hover:bg-fr-primary-hover transition"
                    >
                        <span className="material-symbols-outlined text-base">add</span>
                        Nueva area
                    </button>
                </div>
            </div>

            {/* Tabla */}
            <DataTableElement columns={cols} tableLoad={tableLoad} items={items} />
            {modal.show &&
                <ModalNewSeller filters={filters} setFilters={setFilters} modal={modal} setModal={setModal} />
            }
        </div>
    );
};

export default Categories;
